import type { FeatureGroup } from '../../../../types';
import { DEVELOPMENT_FEATURE_GROUP } from '../group';

export const DEVELOPMENT_DATA_IMPORTS_FEATURE_GROUP: FeatureGroup = {
  guid: '715a49f2-85e3-4ec3-a3eb-76c65204ff00',
  name: 'development:data-imports',
  description: 'Data Imports development tool — bulk-load records into Altru',
  product: 'app',
  parentGuid: DEVELOPMENT_FEATURE_GROUP.guid,
};
